'use strict';

/*global app*/
/*global services*/
/*global blockElement*/
/*global unBlockElement*/
/*global invokeCallback*/
/*global doFilter*/
/*global isEmpty*/
/*global getInputName*/
/*global createObjectCallBack*/
/*global formatAmountByUnit*/
/*global initialize*/
/*global K2Keyboard*/
/*global ProcessUtilities*/
/*global ipsPrepared*/
/*global ipsProcessed*/
/*global ipsNotReleased*/
/*global ipsHigherAmount*/
/*global btBatch*/
/*global btArticle*/
/*global btLocation*/
/*global resSuccess*/
/*global sprintf*/
/*global parseFloatK2*/
/*global formatFloatK2*/
/*global weightBrutto*/

function BasicProcess(containerId, settings) {
  this.containerId = containerId;
  this.$container = $('#' + containerId);
  this.defaultSettings = null;
  this.settings = null;

  this.$form = this.$container.find('form');
  this.$page = $('html');

  this.$keyboardContainer = $('.k2-keyboard-container--onscreen');
  this.keyboard = null;
  this.processUtilities = null;

  this.isFormSubmited = false;
  this.isConfirmedSubmitForm = false;
  this.isFormBack = false;
  this.revertWebDocument = false;

  this.$searchInput = null;
  this.$clearFilter = null;

  this.subDig = 1000;
  this.saveItemsTimeout = null;
  this.saveItemsDelay = 60000;

  this.searchTimeout = null;

  this.userSettings = null;

  this.locationService = null;
  this.inputService = null;

  this.redirectUrl = null;
  this.forceRedirectToUrl = false;

  this.onScreenMessages = [];

  this.initBasic(settings);
}

BasicProcess.prototype = $.extend({}, {
  constructor: 'BasicProcess',

  registerCallbacksBasic: function registerCallbacksBasic() {
    var _this = this;

    _this.$clearFilter.on('filter-clean', function () {
      _this.focusFilterInput();
    });

    _this.$form.on('click', 'a.back-form', function () {
      _this.backForm();

      return false;
    });

    _this.$form.on('click', 'a.submit-form', function () {
      if (_this.$form.find('.blocker').length) {
        //musim kontrolovat zdali se neco nenacita - obcas zadaji umisteni bez potvrzeni a primo kliknou na submit -> musim pockat na donacteni kontroly umisteni
        setTimeout(function () {
          _this.$form.find('a.submit-form').trigger('click');
        }, 500);
      } else {
        _this.submitForm(true);
      }

      return false;
    });

    _this.$form.on('submit', function () {
      _this.doSubmitForm();
      return false;
    });

    _this.$container.on('click', '.process__info', function () {
      _this.showInfo();

      return false;
    });

    _this.$container.on('mouseenter', '.process-item', function () {
      _this.onMouseEnterProcessItem($(this));

      return false;
    });

    _this.$container.on('click', '.process-item__btn-process', function () {
      _this.processItem($(this).closest('tr'), false, false);

      return false;
    });

    _this.$container.on('click', '.process-item__btn-ok', function () {
      _this.itemIsOk($(this).closest('tr'));

      return false;
    });

    _this.$container.on('click', '.process-item__toggle-visibility', function () {
      _this.toggleItemsVisibility(_this.$searchInput.val());
    });

    $('body').on('click', '.process-item__process-all-items', function () {
      _this.processAllItems();

      return false;
    });

    _this.$searchInput.on('change', function () {
      _this.onChangeInputSearch(_this.$searchInput.val());
    });

    _this.$searchInput.on('keyup', function (e) {
      e = e || window.event;
      var keyCode = e.keyCode || e.which;

      if (keyCode === 0 || keyCode === undefined) {
        return _this;
      }

      clearTimeout(_this.searchTimeout);
      _this.searchTimeout = setTimeout(function () {
        _this.onChangeInputSearch(_this.$searchInput.val());

        if (keyCode === 13) {
          _this.onSubmitInputSearch(_this.$searchInput.val());
        }
      }, 250);
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  getFormField: function getFormField(name) {
    var _this = this;
    return _this.$form.find('[name*="[' + name + ']"]');
  },

  getFormValue: function getFormValue(name) {
    var _this = this;
    return $.trim(_this.getFormField(name).val());
  },

  getFormFloatValue: function getFormFloatValue(name) {
    var _this = this;

    var value = _this.getFormValue(name);
    return parseFloatK2(value);
  },

  getFormBoolValue: function getFormBoolValue(name) {
    var _this = this;

    var value = _this.getFormValue(name);
    return value === '1';
  },

  setFormValue: function setFormValue(name, value) {
    var _this = this;
    _this.$form.find('[name*="[' + name + ']"]').val(value);
  },

  setFormFloatValue: function setFormFloatValue(name, value) {
    var _this = this;

    value = formatFloatK2(value);
    _this.setFormValue(name, value);
  },

  setFormBoolValue: function setFormBoolValue(name, value) {
    var _this = this;

    value = value ? '1' : '0';
    _this.setFormValue(name, value);
  },

  getItemField: function getItemField($item, name) {
    return $item.find('[name*="[' + name + ']"]');
  },

  getItemValue: function getItemValue($item, name) {
    var _this = this;
    return $.trim(_this.getItemField($item, name).val());
  },

  getItemFloatValue: function getItemFloatValue($item, name) {
    var _this = this;

    var value = _this.getItemValue($item, name);
    return parseFloatK2(value);
  },

  getItemBoolValue: function getItemBoolValue($item, name) {
    var _this = this;

    var value = _this.getItemValue($item, name);
    return value === '1';
  },

  setItemValue: function setItemValue($item, name, value) {
    var _this = this;
    _this.getItemField($item, name).val(value);
  },

  setItemFloatValue: function setItemFloatValue($item, name, value) {
    var _this = this;

    value = formatFloatK2(value);
    _this.setItemValue($item, name, value);
  },

  getWebDocumentRID: function getWebDocumentRID() {
    var _this = this;

    return _this.getFormValue('WebDocumentRID');
  },

  setWebDocumentRID: function setWebDocumentRID(webDocumentRID) {
    var _this = this;

    _this.setFormValue('WebDocumentRID', webDocumentRID);

    return _this;
  },

  //----------------------------------------------------------------------------

  onAfterInit: function onAfterInit() {
    var _this = this;

    return _this;
  },

  onChangeInputSearch: function onChangeInputSearch(input) {
    var _this = this;

    _this.toggleItemsVisibility(input);

    return _this;
  },

  onSubmitInputSearch: function onSubmitInputSearch(input) {
    var _this = this;

    services.get('barcode-service').find(input, _this.getWarehouseId(), function (res, resData) {
      if (res !== resSuccess) {
        return _this.showMessageHtmlAndFocusFilterInput(sprintf(app.t('barcode.unknown'), input));
      }

      switch (resData.BarcodeType) {
        case btBatch : {
          _this.processItemByBatch(resData);
        }

        break;
        case btArticle : {
          _this.processItemByArticle(resData);
        }

        break;
        case btLocation : {
          _this.processItemByLocation(resData);
        }

        break;
        default : {
          _this.showMessageHtmlAndFocusFilterInput(sprintf(app.t('barcode.unknown'), input));
        }
      }
    });

    return _this;
  },

  onBeforeSubmitPage: function onBeforeSubmitPage(callBack) {
    var _this = this;

    callBack();

    return _this;
  },

  onAfterAppendNewItem: function onAfterAppendNewItem(/*$item, result*/) {
    var _this = this;

    return _this;
  },

  onAfterSaveProcessItemResult: function onAfterSaveProcessItemResult(/*$item, result*/) {
    var _this = this;

    return _this;
  },

  onAfterSubmitForm: function onAfterSubmitForm() {
    var _this = this;

    _this.onAfterSubmitFormFinish();

    return _this;
  },

  onAfterSubmitFormFinish: function onAfterSubmitFormFinish() {
    var _this = this;

    if (_this.redirectUrl) {
      if (_this.forceRedirectToUrl || !_this.settings.redirectToUrlHelp) {
        _this.redirectToUrl(_this.redirectUrl);
      } else {
        app.confirmHtml({
          title: app.t('process.redirect_to_url'),
          content: _this.settings.redirectToUrlHelp
        }, function (ret) {
          if (ret) {
            _this.redirectToUrl(_this.redirectUrl);
          } else {
            _this.redirectToGoTo();
          }
        });
      }
    } else {
      _this.redirectToGoTo();
    }

    return _this;
  },

  onMouseEnterProcessItem: function onMouseEnterProcessItem($item) {
    var _this = this;

    _this.showItemWeight($item);

    return _this;
  },

  //----------------------------------------------------------------------------

  clearFilter: function clearFilter() {
    var _this = this;

    _this.$clearFilter.find('.clear-filter').trigger('click');

    _this.focusFilterInput();

    return _this;
  },

  focusFilterInput: function focusFilterInput() {
    var _this = this;

    _this.$searchInput.focus();

    return _this;
  },

  showMessageHtmlAndFocusFilterInput: function showMessageHtmlAndFocusFilterInput(message) {
    var _this = this;

    app.showMessageHtml(message, function () {
      _this.clearFilter();
    });

    return _this;
  },

  focusRow: function focusRow($row) {
    var _this = this;

    var $firstVisibleRow = $row.nextAll('tr:visible:first');
    if (!$firstVisibleRow.length) {
      $firstVisibleRow = $row.prevAll('tr:visible:first');
    }

    if ($firstVisibleRow.length) {
      $(window).scrollTop($firstVisibleRow.offset().top - ($firstVisibleRow.height() * 2));
    }

    return _this;
  },

  showInfo: function showInfo() {
    var _this = this;

    var params = {
      DocumentType: _this.settings.documentType,
      WebDocumentRID: _this.getWebDocumentRID(),
      JoiningSymbol: _this.getFormValue('JoiningSymbol'),
      HandlingUnit: _this.getFormValue('HandlingUnit'),
      Area: app.param('active_area'),
    };

    services.get('info').showInfo(params);

    return _this;
  },

  //----------------------------------------------------------------------------

  checkZeroStockLevel: function checkZeroStockLevel($item, result, callback) {
    var _this = this;

    if (_this.settings.editedLocation === 'FromLocation') {
      var data = {
        ArticleId: _this.getItemFloatValue($item, 'ArticleId'),
        StockId: _this.getWarehouseId(),
        Location: _this.getItemValue($item, _this.settings.editedLocation),
        LocationId: _this.getItemFloatValue($item, _this.settings.editedLocation + 'Id'),
        Amount: result.Amount * _this.getItemValue($item, 'AmountRatio'),
        JoiningSymbol: _this.getFormValue('JoiningSymbol'),
      };

      services.get('warehouse-service').checkZeroStockLevel(data, function () {
        _this.focusFilterInput();
      });
    } else {
      invokeCallback(callback);
    }

    return _this;
  },

  //----------------------------------------------------------------------------

  onBeforeLeavePage: function onBeforeLeavePage() {
    var _this = this;

    var inHold = _this.$form.find('[name$="[InHold]"]').val();
    if (inHold) {
      $.getSync(app.path('process_unhold_document', {
        WebDocumentRID: _this.getWebDocumentRID(),
        RevertWebDocument: _this.revertWebDocument ? '1' : '0'
      }));
    }

    return _this;
  },

  backForm: function backForm() {
    var _this = this;

    app.confirmHtml(app.t('k2_location.confirm_leave_page_help'), function (ret) {
      if (ret) {
        _this.isFormBack = true;
        _this.revertWebDocument = true;

        _this.onBeforeLeavePage();

        _this.redirectToGoTo();
      }
    });

    return _this;
  },

  redirectToUrl: function redirectToUrl(url) {
    var _this = this;

    location.href = url;

    return _this;
  },

  redirectToGoTo: function redirectToGoTo() {
    var _this = this;

    location.href = $('.location__go-to').data('location_href');

    return _this;
  },

  submitFormSuccess: function submitFormSuccess(args) {
    var _this = this;
    var res = args[0];

    unBlockElement(_this.$form);

    if (res.msg === 'SUCCESS') {
      _this.isFormSubmited = true;

      _this.onAfterSubmitForm();
    } else if (res.msg === 'REDIRECT') {
      _this.isFormSubmited = true;
      _this.redirectUrl = res.data.url;
      _this.forceRedirectToUrl = res.data.forceRedirect;

      _this.onAfterSubmitForm();
    } else if (res.msg === 'NOT_VALID') {
      app.viewErrorMessage(app.t('form.not_valid'));
    } else {
      if (typeof res === 'object' && 'error' in res) {
        app.viewErrorMessage(res.error);
      } else {
        app.viewErrorMessage();
      }
    }

    return _this;
  },

  submitFormFailed: function submitFormFailed() {
    var _this = this;

    unBlockElement(_this.$form);

    app.viewErrorMessage(app.t('process.process_failed_connection'));

    return _this;
  },

  doSubmitForm: function doSubmitForm() {
    var _this = this;

    _this.onBeforeSubmitPage(function () {
      blockElement(_this.$form);

      $.ajax({
        url: _this.$form.attr('action'),
        data: new FormData(_this.$form[0]),
        processData: false,
        contentType: false,
        timeout: 30 * 60 * 1000,
        type: 'POST',
        success: createObjectCallBack(_this, 'submitFormSuccess'),
        error: createObjectCallBack(_this, 'submitFormFailed'),
      });
    });

    return _this;
  },

  doSaveAndQuickForm: function doSaveAndQuickForm() {
    var _this = this;

    if (_this.getProcessedItems().length) {
      _this.saveItems();
    }

    _this.redirectToGoTo();

    return _this;
  },

  submitForm: function submitForm(updateAlerts) {
    var _this = this;

    if (_this.isConfirmedSubmitForm || _this.isFormValid(updateAlerts)) {
      _this.$form.submit();
    } else {
      if (app.param('is_allowed_save_partial_processing')) {
        if (!_this.isConfirmedSubmitForm) {
          //pokud není formulář validní, musíme si potvrdit submitu - provede se pouze ulozeni a vyskoceni - castecne zpracovani nelze!!!
          _this.confirmSubmitForm();
        }
      } else {
        var message = app.param('not_allowed_submit_message') || app.t('form.invalid_form_not_allowed_submit');
        app.showMessageHtml(message);
      }
    }

    return _this;
  },

  isFormValid: function isFormValid(updateAlerts) {
    var _this = this;

    var isValid = true;

    if (!app.param('is_allowed_partial_processing')) {
      var $items = _this.$form.find('.process-items');
      $items.find('.process-item').each(function () {
        var $item = $(this);
        $item.removeClass('text-danger');

        var processStatus = _this.getProcessStatusByItem($item);
        if (processStatus === ipsPrepared) {
          isValid = false;
          if (updateAlerts) {
            $item.addClass('text-danger');
          }
        }
      });
    }

    return isValid;
  },

  confirmSubmitForm: function confirmSubmitForm() {
    var _this = this;

    var confirmMessage = app.param('confirm_submit_message') || app.t('form.confirm_submit_help');

    app.confirmHtml({ title: app.t('form.confirm_submit'), content: confirmMessage }, function (ret) {
      if (ret) {
        if (_this.settings.allowedProcessNotCompletedForm) {
          _this.isConfirmedSubmitForm = true;

          _this.$form.submit();
        } else {
          _this.doSaveAndQuickForm();
        }
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  getProcessStatusByItem: function getProcessStatusByItem($item) {
    var processStatus = parseInt($item.find('[name$="[ProcessStatus]"]').val());

    return processStatus;
  },

  getPreparedItems: function getPreparedItems() {
    var _this = this;

    var $items = _this.$form.find('.process-items');
    return $items.find('.process-item').filter(function () {
      var $item = $(this);

      var processStatus = _this.getProcessStatusByItem($item);
      return processStatus === ipsPrepared;
    });
  },

  getProcessedItems: function getProcessedItems() {
    var _this = this;

    var $items = _this.$form.find('.process-items');
    return $items.find('.process-item').filter(function () {
      var $item = $(this);

      var processStatus = _this.getProcessStatusByItem($item);
      return processStatus !== ipsPrepared;
    });
  },

  getItems: function getItems() {
    var _this = this;

    return _this.$form.find('.process-items').find('.process-item');
  },

  getItemsByArticle: function getItemsByArticle(articleId) {
    var _this = this;

    return _this.$form.find('.process-items').find('[name$="[ArticleId]"][value="' + articleId + '"]').closest('.process-item');
  },

  getWarehouseId: function getWarehouseId() {
    var _this = this;

    return _this.getFormFloatValue((_this.settings.editedLocation === 'FromLocation' ? 'FromStock' : 'ToStock') + 'Id');
  },

  getMainWarehouseId: function getMainWarehouseId() {
    var _this = this;

    var mainWarehouseId = _this.getFormFloatValue('MainWarehouseId');

    if (!mainWarehouseId) {
      mainWarehouseId = _this.getWarehouseId();
    }

    return mainWarehouseId;
  },

  createRequestToSaveItems: function createRequestToSaveItems() {
    var _this = this;

    _this.saveItemsTimeout = setTimeout(function () {
      _this.saveItems();
    }, _this.saveItemsDelay);

    return _this;
  },

  saveItemsSuccess: function saveItemsSuccess(arg) {
    var _this = this;

    var res = arg[0];
    if (res.msg === 'SUCCESS') {
      _this.setWebDocumentRID(res.data.WebDocumentRID);
    } else {
      _this.createRequestToSaveItems();
    }

    return _this;
  },

  saveItemsFailed: function saveItemsFailed() {
    var _this = this;

    //pokud se nepodari ulozit, tak to zkusime za chvilku znovu
    _this.createRequestToSaveItems();

    return _this;
  },

  saveItems: function saveItems() {
    var _this = this;

    clearTimeout(_this.saveItemsTimeout);
    $.postK2(app.path('process_save_items'), _this.$form.serialize(), createObjectCallBack(_this, 'saveItemsSuccess'), createObjectCallBack(_this, 'saveItemsFailed'));

    return _this;
  },

  //----------------------------------------------------------------------------

  getMismatchNewItem: function getMismatchNewItem(result) {
    return result.Mismatch;
  },

  getMismatchOldItem: function getMismatchOldItem(result, isNewItem) {
    if (!isNewItem) {
      return result.Mismatch;
    }

    return 0;
  },

  //----------------------------------------------------------------------------

  changeItemFilterText: function changeItemFilterText($item, appendText) {
    var _this = this;

    var filterText = $item.data('filter_text');

    appendText = appendText.toLowerCase();
    if (filterText.indexOf(appendText) < 0) {
      filterText += '|' + appendText;

      $item.data('filter_text', filterText);
      $item.attr('data-filter_text', filterText);
    }

    return _this;
  },

  changeItemProcessStatus: function changeItemProcessStatus($item, status) {
    $item.find('[name$="[ProcessStatus]"]').val(status);

    $item.find('.process-item__is-processed').removeClass('hidden');
    $item.removeClass('process-item--done');
    $item.removeClass('process-item--mismatch');
    $item.removeClass('process-item--not-released');

    switch (status) {
      case ipsPrepared: {
        $item.find('.process-item__is-processed').addClass('hidden');
      }

      break;
      case ipsHigherAmount:
      case ipsProcessed: {
        $item.addClass('process-item--done');
      }

      break;
      case ipsNotReleased: {
        $item.addClass('process-item--not-released');
        $item.find('.process-item__is-processed').addClass('hidden');
      }

      break;
    }

    var mismatch = $item.find('[name$="[Mismatch]"]').val();
    if (mismatch) {
      mismatch = parseInt(mismatch);

      if (mismatch > 0) {
        $item.addClass('process-item--mismatch');
      }
    }
  },

  cloneItem: function cloneItem($item) {
    var _this = this;

    var $wrapper = $item.closest('.process-items');
    var prototypeForm = $wrapper.data('prototype');
    var index = parseInt($wrapper.data('last_index'));
    var newForm = prototypeForm.replace(/__name__/g, index + 1);
    var $newCollectionItem = $(newForm);

    $wrapper.data('last_index', index + 1);
    $newCollectionItem.insertAfter($item);
    initialize($newCollectionItem);

    //zkopiruji vse potrebne
    $item.find('input').each(function () {
      var $input = $(this);

      var name = getInputName($input);
      $newCollectionItem.find('[name$="[' + name + ']"]').val($input.val());
    });

    $item.find('.process-item__title').each(function () {
      var $title = $(this);
      $newCollectionItem.find('.process-item__title[data-title_name="' + $title.data('title_name') + '"]').html($title.html());
    });

    $newCollectionItem.find('[name$="[IsNew]"]').val('1');
    $newCollectionItem.find('[name$="[Mismatch]"]').val('');
    $newCollectionItem.attr('data-filter_text', $item.data('filter_text'));

    if ($item.hasClass('process-item--note')) {
      $newCollectionItem.addClass('process-item--note');
    }

    if ($item.hasClass('process-item--cross')) {
      $newCollectionItem.addClass('process-item--cross');
    }

    if ($item.find('.process-item__sign').length) {
      $newCollectionItem.find('.process-item__sign').html($item.find('.process-item__sign').html());
    }

    _this.changeItemProcessStatus($newCollectionItem, ipsPrepared);

    return $newCollectionItem;
  },

  onAfterEditItem: function onAfterEditItem($row, result) {
    var _this = this;

    $row.find('[name$="[IsReleased]"]').val(result.IsReleased);
    $row.find('[name$="[Package]"]').val(result.Package);
    $row.find('[name$="[PackageUnits]"]').val(result.PackageUnits);
    $row.find('[name$="[PackageCount]"]').val(result.PackageCount);
    $row.find('[name$="[ToHandlingUnitRID]"]').val(result.HandlingUnitRID);

    _this.changeItemFilterText($row, result.Location);

    if (_this.settings.isPickingProcess && result.Amount === 0) {
      //pokud byla nula, tak se nepridava nova polozka, ale necha se puvodni, se kterou se pracuje jako s novou
      _this.onAfterAppendNewItem($row, result);
    }

    _this.onAfterSaveProcessItemResult($row, result);

    _this.toggleItemsVisibility(_this.$searchInput.val());
    _this.saveItems();

    if (_this.settings.clearFilterOnProcessItem) {
      _this.clearFilter();

      //zatim takto prasacky, poresit nejak lepe
      setTimeout(function () {
        _this.focusFilterInput();
      }, 100);

      setTimeout(function () {
        _this.focusRow($row);
      }, 400);
    }

    return _this;
  },

  addItem: function addItem(data, result) {
    var _this = this;

    //zbozi jeste neexistuje, vytvorime nove
    var $wrapper = $('.process-items');
    var prototypeForm = $wrapper.data('prototype');
    var index = parseInt($wrapper.data('last_index'));
    var newForm = prototypeForm.replace(/__name__/g, index + 1);
    var $newCollectionItem = $(newForm);

    $wrapper.data('last_index', index + 1);
    $wrapper.find('tbody').append($newCollectionItem);
    initialize($newCollectionItem);

    var $row = $newCollectionItem;

    //prekopirujeme vlastnosti, ktere jsme obdrzeli v datech
    for (var prop in data) {
      if (prop in data) {
        var $input = $row.find('[name$="[' + prop + ']"]');
        if ($input.length) {
          $input.val(data[prop]);
        }

        var $td = $row.find('[data-title_name="' + prop + '"]');
        if ($td.length) {
          $td.text(data[prop]);
        }
      }
    }

    //nastavime priznak o zpracovani
    $row.find('[name$="[ProcessStatus]"]').val(ipsProcessed);
    $row.find('[name$="[IsNew]"]').val(1);

    var unit = $row.find('[name$="[Unit]"]').val();
    var amount = formatAmountByUnit(result.Amount, unit);

    $row.find('[name$="[Amount]"]').val(result.Amount);
    $row.find('[name$="[AmountOrig]"]').val(0);
    $row.find('[data-title_name="Amount"]').text(amount + ' ' + unit);

    _this.changeItemProcessStatus($row, ipsProcessed);

    _this.onAfterEditItem($row, result);

    return _this;
  },

  editItem: function editItem($row, result) {
    var _this = this;

    var isNewItem = false;
    var amount = 0;
    var articleId = parseFloat($row.find('[name$="[ArticleId]"]').val());
    var prevAmount = parseFloat($row.find('[name$="[Amount]"]').val());
    var origAmount = parseFloat($row.find('[name$="[AmountOrig]"]').val());
    var unit = $row.find('[name$="[Unit]"]').val();

    //aktualizujeme si data dle toho, co jsme si vratili
    if (_this.settings.isReceiptProcess) {
      $row.find('[name$="[UnitWeightNetto]"]').val(result.UnitWeightNetto);
      $row.find('[name$="[UnitWeightBrutto]"]').val(result.UnitWeightBrutto);

      _this.getItemsByArticle(articleId).each(function () {
        var $item = $(this);

        $item.find('[name$="[UnitWeightNetto]"]').val(result.UnitWeightNetto);
        $item.find('[name$="[UnitWeightBrutto]"]').val(result.UnitWeightBrutto);
      });
    }

    //pouze pokud se neco vydalo, nebo se jedna o vychystani prevodu - pokud bych tam nechal nulu, tak mi uplne zmizne polozka a to nechceme
    //mozna by to melo byt vzdy, ale bylo by nutne to nejak protestovat!!!
    if (prevAmount > result.Amount && (result.Amount > 0 || _this.settings.isTransferNoteRelease)) {
      //pokud nesedi polozka, tak ji musime rozpadnout

      var $newCollectionItem = _this.cloneItem($row);

      //upravim mnozstvi na nove polozce
      amount = parseFloat($newCollectionItem.find('[name$="[Amount]"]').val());
      var newAmount = (_this.subDig * amount - _this.subDig * result.Amount) / _this.subDig; //kvuli chybe pri zaokrouhlovani musime udelat takto ... jinak 0.15 - 0.1 = 0.04999999

      newAmount = formatAmountByUnit(newAmount, unit);
      origAmount = (_this.subDig * origAmount - _this.subDig * newAmount) / _this.subDig;

      $newCollectionItem.find('.process-item__title--amount').text(newAmount + ' ' + unit);
      $newCollectionItem.find('[name$="[Amount]"]').val(newAmount);
      $newCollectionItem.find('[name$="[AmountOrig]"]').val(newAmount);
      $newCollectionItem.find('[name$="[Mismatch]"]').val(_this.getMismatchNewItem(result));

      if (result.IsReleased) {
        //pokud zadal dovydano, tak nova polozka bude take oznacena jako zpracovana, ale nebude mit priznak dovydano
        _this.changeItemProcessStatus($newCollectionItem, ipsProcessed);
      } else if (_this.settings.isTransferNoteProcess && _this.getMismatchNewItem(result)) {
        _this.changeItemProcessStatus($newCollectionItem, ipsProcessed);
      }

      _this.onAfterAppendNewItem($newCollectionItem, result);

      isNewItem = true;
    }

    //nazaver aktualizujeme puvodni polozku - aby se nam nekopiroval do nove
    amount = formatAmountByUnit(result.Amount, unit);
    if (_this.settings.isPickingProcess && result.Amount === 0) {
      //pokud byla nula, tak se nastavi zpet puvodni mnozstvi
      amount = formatAmountByUnit(prevAmount, unit);
    }

    $row.find('.process-item__title--amount').text(amount + ' ' + unit);
    $row.find('[name$="[Amount]"]').val(amount);
    $row.find('[name$="[AmountOrig]"]').val(origAmount);
    $row.find('[name$="[Mismatch]"]').val(_this.getMismatchOldItem(result, isNewItem));

    if (_this.settings.editedLocation === 'ToLocation') {
      $row.find('.process-item__title--to-location').text(result.Location);
    } else {
      $row.find('.process-item__title--from-location').text(result.Location);
    }

    $row.find('[name$="[' + _this.settings.editedLocation + ']"]').val(result.Location);
    $row.find('[name$="[' + _this.settings.editedLocation + 'Id]"]').val(result.LocationId);

    $row.find('[name$="[AreaId]"]').val(result.AreaId);
    $row.find('[name$="[IsIncreasedAmount]"]').val(result.IsIncreasedAmount);

    if (prevAmount < result.Amount) {
      _this.changeItemProcessStatus($row, ipsHigherAmount);
    } else {
      _this.changeItemProcessStatus($row, ipsProcessed);
    }

    _this.onAfterEditItem($row, result);

    return _this;
  },

  itemIsOk: function itemIsOk($row) {
    var _this = this;

    var data = {
      Amount: $row.find('[name$="[Amount]"]').val(),
      Mismatch: 0,
      Location: $row.find('[name$="[' + _this.settings.editedLocation + ']"]').val(),
      LocationId: $row.find('[name$="[' + _this.settings.editedLocation + 'Id]"]').val(),
      AreaId: $row.find('[name$="[AreaId]"]').val(),
      IsIncreasedAmount: false
    };

    _this.editItem($row, data);

    return _this;
  },

  processItem: function processItem($row, isLocationScanned, isArticleScanned) {
    var _this = this;

    var settings = $.extend({}, _this.settings.itemForm, {
      saveCallBack: function (result) {
        _this.editItem($row, result);
      },

      closeCallBack: function () {
        _this.clearFilter();
      },

      editedLocation: _this.settings.editedLocation,
      requiredConfirmLocation: _this.settings.requiredConfirmLocation,
      isLocationScanned: isLocationScanned,
      isArticleScanned: isArticleScanned,
    });

    var data = _this.getItemData($row);

    if (_this.getFormBoolValue('IsRequiredPackage') && data.Package === '0') {
      settings.allowedPackage = true;
    }

    services.get('item-form').open(settings, data);

    return _this;
  },

  processNewItem: function processNewItem(data, isLocationScanned, isArticleScanned) {
    var _this = this;

    var settings = $.extend({}, _this.settings.itemForm, {
      saveCallBack: function (result) {
        _this.addItem(data, result);
      },

      closeCallback: function () {
        _this.clearFilter();
      },

      editedLocation: _this.settings.editedLocation,
      requiredConfirmLocation: false,
      isLocationScanned: isLocationScanned,
      isArticleScanned: isArticleScanned,
    });

    data = $.extend({}, {
      FromStockId: _this.$form.find('[name$="[FromStockId]"]').val(),
      ToStockId: _this.$form.find('[name$="[ToStockId]"]').val(),
      FromLocationId: data.LocationId,
      FromLocation: data.LocationAbbr,
      StockId: _this.getWarehouseId(),
      IsAllowedIncreaseAmount: '1' //musi byt takto, nikoliv true ... kvuli dalsim kontrolam a predavani do formularu
    }, data);

    services.get('item-form').open(settings, data);

    return _this;
  },

  itemNotFound: function itemNotFound(/*data*/) {
    var _this = this;

    _this.showMessageHtmlAndFocusFilterInput(app.t('article.not_found'));

    return _this;
  },

  processItemByBatch: function processItemByBatch(data) {
    var _this = this;

    var $items = _this.$form.find('.process-items .process-item:not(.process-item--done) [name$="[ArticleId]"][value="' + data.ArticleId + '"]');
    if (!$items.length) {
      _this.itemNotFound(data);
      return;
    }

    _this.toggleItemsVisibility(data.Abbr);

    $items = $items.closest('tr').find('[name$="[BatchId]"][value="' + data.Id + '"]');
    if (!$items.length) {
      _this.itemNotFound(data);
      return;
    }

    _this.processItem($items.closest('tr').first(), false, true);

    return _this;
  },

  processItemByArticle: function processItemByArticle(data) {
    var _this = this;

    var $items = _this.$form.find('.process-items .process-item:not(.process-item--done) [name$="[ArticleId]"][value="' + data.Id + '"]');
    if (!$items.length) {
      _this.itemNotFound(data);
      return;
    }

    _this.toggleItemsVisibility(data.Abbr);

    _this.processItem($items.closest('tr').first(), false, true);

    return _this;
  },

  processItemByLocation: function processItemByLocation(data) {
    var _this = this;

    var $items = _this.$form.find('.process-items .process-item:not(.process-item--done) [name$="[' + _this.settings.editedLocation + 'Id]"][value="' + data.Id + '"]');
    if (!$items.length) {
      _this.itemNotFound(data);
      return;
    }

    _this.toggleItemsVisibility(data.Abbr);

    _this.processItem($items.closest('tr').first(), true, false);

    return _this;
  },

  toggleItemsVisibility: function toggleItemsVisibility(input) {
    var _this = this;

    var onlyNotProcessed = _this.$form.find('.process-item__toggle-visibility').is(':checked');
    var $items = _this.$form.find('.process-items .process-item');

    $items.removeClass('process-item--done-hidden');
    doFilter(_this.$container, 'process-item', input, null, null, 'process-item--hidden');
    if (onlyNotProcessed) {
      $items.filter(function () {
        var $item = $(this);

        return _this.getProcessStatusByItem($item) !== ipsPrepared;
      }).addClass('process-item--done-hidden');
    }

    return _this;
  },

  getItemData: function getItemData($row) {
    var _this = this;

    var data = _this.getHeaderData();

    data.Location = $row.find('[name$="[' + _this.settings.editedLocation + ']"]').val();
    data.LocationId = $row.find('[name$="[' + _this.settings.editedLocation + 'Id]"]').val();

    //nacteme vsechny informace o polozce
    $row.find('input').each(function () {
      var $input = $(this);

      var name = getInputName($input);
      data[name] = $input.val();
    });

    return data;
  },

  getHeaderData: function getHeaderData() {
    var _this = this;

    var data = {
      WebDocumentRID: _this.getWebDocumentRID(),
      DocumentType: _this.$form.find('[name$="[DocumentType]"]').val(),
      Status: _this.$form.find('[name$="[Status]"]').val(),
      TransportType: _this.$form.find('[name$="[TransportType]"]').val(),
      FromStockId: _this.$form.find('[name$="[FromStockId]"]').val(),
      ToStockId: _this.$form.find('[name$="[ToStockId]"]').val(),
      StockId: _this.getWarehouseId(),
      MainWarehouseId: _this.getMainWarehouseId(),
    };

    return data;
  },

  //----------------------------------------------------------------------------

  changeKeyboardPosition: function changeKeyboardPosition(/*ui*/) {
    var _this = this;

    /*
    _this.userSettings.keyboard.position.top = ui.position.top + 'px';
    _this.userSettings.keyboard.position.left = ui.position.left + 'px';

    services.get('cookies').setJSON('basic-process-user-settings', _this.userSettings);
    */

    return _this;
  },

  initKeyboard: function initKeyboard() {
    var _this = this;

    if (!_this.$keyboardContainer.length) {
      return _this;
    }

    _this.keyboard = new K2Keyboard('basic-process');
    _this.$keyboardContainer.append(_this.keyboard.getKeyboard());
    _this.$keyboardContainer.draggable({
      stop: function (event, ui) {
        _this.changeKeyboardPosition(ui);
      }
    });

    //_this.$keyboardContainer.css(_this.userSettings.keyboard.position);

    _this.keyboard.reset();
    _this.keyboard.setCustomInput(_this.$searchInput);
    _this.keyboard.hideInput();

    _this.checkKeyboardPosition();

    return _this;
  },

  checkKeyboardPosition: function checkKeyboardPosition() {
    var _this = this;

    var position = _this.$keyboardContainer.position();

    if (position.left > $(window).width() || position.top > $(window).height()) {
      _this.$keyboardContainer.css({ top: '', left: '' });
    }

    return _this;
  },

  doViewOnScreenMessages: function doViewOnScreenMessages(callback) {
    var _this = this;

    if (_this.onScreenMessages.length === 0) {
      invokeCallback(callback);
      return;
    }

    var message = _this.onScreenMessages.shift();

    if (message.type === 'info') {
      app.showMessageHtml(message.message, function () {
        _this.doViewOnScreenMessages(callback);
      });
    }

    if (message.type === 'warning') {
      app.showWarningHtml(message.message, function () {
        _this.doViewOnScreenMessages(callback);
      });
    }

    return _this;
  },

  addOnScreenMessage: function addOnScreenMessage(type, message) {
    var _this = this;

    if (isEmpty(message)) {
      return;
    }

    _this.onScreenMessages.push({ type: type, message: message });

    return _this;
  },

  viewOnScreenMessages: function viewOnScreenMessages(callback) {
    var _this = this;

    _this.addOnScreenMessage('info', _this.$form.find('[name$="[OnScreenMessage]"]').val());
    _this.addOnScreenMessage('info', _this.$form.find('[name$="[OnScreenMessage2]"]').val());
    _this.addOnScreenMessage('warning', _this.$form.find('[name$="[OnScreenWarning]"]').val());
    _this.addOnScreenMessage('warning', _this.$form.find('[name$="[OnScreenWarning2]"]').val());
    _this.addOnScreenMessage('warning', _this.$form.find('[name$="[OnScreenWarning3]"]').val());

    _this.doViewOnScreenMessages(callback);

    return _this;
  },

  showItemsInfo: function showItemsInfo() {
    var _this = this;

    if (_this.$form.find('.process-item__title--info').length === 0) {
      return _this;
    }

    _this.processUtilities.updateProcessItemsInfo(_this.$form.find('.process-item'));

    return _this;
  },

  showItemWeight: function showItemWeight($item) {
    var _this = this;

    var weight = _this.processUtilities.getItemWeight($item, weightBrutto);

    _this.$form.find('.process-form__weight').text(weight);

    return _this;
  },

  printCustomerLabels: function printCustomerLabels() {
    var _this = this;

    if (!_this.getFormBoolValue('IsRequiredPrintingCustomersSN')) {
      return _this;
    }

    //v MEKRSu se neptam, rovnou tisknu
    if (app.param('print_customer_sn')) {
      app.printer.printCustomerLabels(_this.getWebDocumentRID());

      return _this;
    }

    //najdeme si polozky, ktere obsahuji stitek - budou se tisknout
    var $items = _this.getPreparedItems().filter(function () {
      var serialNumber = _this.getItemValue($(this), 'SerialNumber');

      return !isEmpty(serialNumber);
    });

    var $unpackingItems = _this.getPreparedItems().filter(function () {
      return _this.getItemBoolValue($(this), 'IsUnpacking');
    });

    //v PEMATEXU se jeste ptam zdali tisknout
    app.confirmCancelHtml(sprintf(app.t('release_note.print_customer_sn'), $items.length, $unpackingItems.length), function (ret) {
      if (ret === null) {
        //dal storno
        return services.get('printer-setting').openPrinterSetting(function () {
          if (app.param('print_customer_sn_auto')) {
            _this.setFormBoolValue('PrintCustomerSNFromProcessing', true);
          }

          _this.focusFilterInput();
        });
      }

      if (ret) {
        //VSE pokud chce vytisknout, vytiskneme
        app.printer.printCustomerLabels(_this.getWebDocumentRID());
      } else {
        //rozbal
        app.printer.printCustomerLabels(_this.getWebDocumentRID(), true);
      }
    });
  },

  //----------------------------------------------------------------------------

  processAllItems: function processAllItems() {
    var _this = this;

    _this.getPreparedItems().each(function () {
      _this.itemIsOk($(this));
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  initBasic: function initBasic(settings) {
    var _this = this;

    _this.processUtilities = new ProcessUtilities();

    _this.defaultSettings = {
      documentType: 0,
      editedLocation: 'ToLocation', //nebo 'FromLocation'
      requiredConfirmLocation: false,
      clearFilterOnProcessItem: false,
      redirectToUrlHelp: '',
      allowedProcessNotCompletedForm: false,
      isPickingProcess: false,
      isTransferNoteProcess: false,
      isTransferNoteRelease: false,
      isOutgoingControl: false,
      isReceiptProcess: false,
      itemForm: {} //definice defaultnich parametru je primo v item-form
    };

    _this.settings = $.extend({}, _this.defaultSettings, settings);

    _this.userSettings = {
      keyboard: {
        position: {
          top: 'auto',
          bottom: '30px',
          left: 'calc(50% - 142px)'
        }
      }
    };

    var cookieValue = services.get('cookies').getJSON('basic-process-user-settings');
    _this.userSettings = $.extend(true, {}, _this.userSettings, cookieValue);

    _this.$searchInput = _this.$container.find('input[name="search"]');
    _this.$clearFilter = _this.$container.find('.search-clear-filter');
    _this.$clearFilter.k2_filterClear({
      callBack: function () {
        _this.onChangeInputSearch('');
      }
    });

    _this.onChangeInputSearch('');
    _this.registerCallbacksBasic();

    _this.initKeyboard();

    _this.showItemsInfo();

    _this.locationService = services.get('location-service');
    _this.inputService = services.get('input-service');

    _this.viewOnScreenMessages(function () {
      _this.onAfterInit();

      _this.focusFilterInput();
    });

    return _this;
  }
});
